import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const FileDownloadIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Stockholm-icons / Files / Downloaded file">
        <path
          id="Combined Shape"
          opacity="0.3"
          d="M5.85714 2H13.7364C14.0911 2 14.4343 2.12568 14.7051 2.35474L19.4687 6.38394C19.8057 6.66895 20 7.08788 20 7.5292V20.0833C20 21.8739 19.9796 22 18.1429 22H5.85714C4.02045 22 4 21.8739 4 20.0833V3.91667C4 2.12612 4.02045 2 5.85714 2Z"
          {...svgAttrs}
        />
        <path
          id="Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.2691 12.654C15.5443 12.3291 15.3133 11.8309 14.8875 11.8309H12.9311V9.82324C12.9311 9.5471 12.7072 9.32324 12.4311 9.32324H11.4078C11.1316 9.32324 10.9078 9.5471 10.9078 9.82324V11.8309L8.9513 11.8309C8.52555 11.8309 8.2946 12.3291 8.5697 12.654L11.5378 16.1597C11.7375 16.3955 12.1013 16.3955 12.301 16.1597L15.2691 12.654Z"
          {...svgAttrs}
        />
      </g>
    </svg>
  );
};

export default FileDownloadIcon;
